import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Textarea } from '../../components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/select';
import { ArrowLeft, Loader2 } from 'lucide-react';
import { toast } from 'sonner';

export default function CreateCourse() {
  const navigate = useNavigate();
  const [form, setForm] = useState({ title: '', description: '', course_type: 'prenatal', trimester: '', access_level: 'elite' });
  const [saving, setSaving] = useState(false);

  const handleCreate = async () => {
    if (!form.title.trim()) { toast.error('Course title is required'); return; }
    setSaving(true);
    try {
      const res = await api.post('/api/courses', {
        ...form,
        trimester: form.trimester ? parseInt(form.trimester) : null,
      });
      toast.success('Course created! Now add episodes.');
      navigate(`/admin/courses/${res.data.id}`);
    } catch (err) { toast.error(err.response?.data?.detail || 'Failed to create'); }
    setSaving(false);
  };

  return (
    <div className="space-y-6 max-w-2xl" data-testid="create-course-page">
      <div className="flex items-center gap-3">
        <Button variant="ghost" size="icon" onClick={() => navigate('/admin/courses')}><ArrowLeft className="h-5 w-5" /></Button>
        <h1 className="font-heading text-3xl font-semibold tracking-tight">Create Course</h1>
      </div>

      <Card className="rounded-2xl">
        <CardContent className="pt-6 space-y-5">
          <div>
            <label className="text-sm font-medium mb-1.5 block">Course Title</label>
            <Input value={form.title} onChange={e => setForm(p => ({ ...p, title: e.target.value }))} placeholder="e.g. Prenatal Yoga Basics" data-testid="course-title" />
          </div>
          <div>
            <label className="text-sm font-medium mb-1.5 block">Description</label>
            <Textarea value={form.description} onChange={e => setForm(p => ({ ...p, description: e.target.value }))} rows={4} placeholder="What will learners gain from this course?" />
          </div>
          <div className="grid grid-cols-3 gap-4">
            <div>
              <label className="text-sm font-medium mb-1.5 block">Type</label>
              <Select value={form.course_type} onValueChange={v => setForm(p => ({ ...p, course_type: v }))}>
                <SelectTrigger data-testid="course-type"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="prenatal">Prenatal</SelectItem>
                  <SelectItem value="postnatal">Postnatal</SelectItem>
                  <SelectItem value="ttc">TTC</SelectItem>
                </SelectContent>
              </Select>
            </div>
            <div>
              <label className="text-sm font-medium mb-1.5 block">Access Level</label>
              <Select value={form.access_level} onValueChange={v => setForm(p => ({ ...p, access_level: v }))}>
                <SelectTrigger data-testid="access-level"><SelectValue /></SelectTrigger>
                <SelectContent>
                  <SelectItem value="elite">Elite</SelectItem>
                  <SelectItem value="trial_paid">Paid Trial</SelectItem>
                  <SelectItem value="free_trial">Free Trial</SelectItem>
                </SelectContent>
              </Select>
            </div>
          </div>
          <Button className="w-full" onClick={handleCreate} disabled={saving} data-testid="create-course-submit">
            {saving ? <Loader2 className="h-4 w-4 mr-2 animate-spin" /> : null}Create Course
          </Button>
        </CardContent>
      </Card>
    </div>
  );
}
